module.exports = __webpack_public_path__ + "img/nullFile.16970413.svg";